import { MailMessageDataProviderItem } from './getFileProviderItems/getMailMessageFileProviderItems';
import { OneDriveProItemsSkipTokenPagingMetadata } from './types/OneDriveProItemsSkipTokenPagingMetadata';
import {
    GDriveDataProviderItem,
    GDriveGetAttachmentDataProviderItemsResponse,
} from './getFileProviderItems/getGDriveFileProviderItems';

// Exported services
export { searchFileProviderItems } from './searchFileProviderItems/searchFileProviderItems';
export { getFileProviderItems } from './getFileProviderItems/getFileProviderItems';
export {
    clearFileProviderToken,
    isTokenRetrievalError,
    TokenRetrievalError,
    getOneDriveProAccessTokenForResource,
    GDriveItemsResponse,
} from 'owa-fileprovider-services';

// Exported utils
export { isOneDriveProScope, isOneDriveProItemsSkipTokenPagingMetadata } from './utils/typeGuards';
export { getMimeTypeForOneDriveItem } from './utils/getMimeTypeForOneDriveItem';

// Exported types
export {
    GDriveGetAttachmentDataProviderItemsResponse,
    GDriveDataProviderItem,
    MailMessageDataProviderItem,
    OneDriveProItemsSkipTokenPagingMetadata,
};
